'use strict';

var Logger = require('../dist/logger')
var WebConsoleWriter = require('./writers/web-console')
var EndpointWriter = require('./writers/endpoint')

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = Logger.default;
exports.WebConsoleWriter = WebConsoleWriter.default,
exports.EndpointWriter = EndpointWriter.default

